const TechnologyItems = ({ technologies }) => (
  <div className="mk-technology-marquee__group flex shrink-0 items-center gap-10 pr-10 sm:gap-12 sm:pr-12">
    {technologies.map((technology) => (
      <div
        key={technology.name}
        className="group flex shrink-0 items-center gap-2.5 text-sm font-semibold text-slate-700 transition-colors duration-300 hover:text-slate-900 sm:text-base"
      >
        <img
          src={technology.logo}
          alt=""
          aria-hidden="true"
          loading="lazy"
          decoding="async"
          className="h-5 w-5 object-contain opacity-80 transition duration-300 group-hover:opacity-100 sm:h-6 sm:w-6"
        />
        <span>{technology.name}</span>
      </div>
    ))}
  </div>
);

const TechnologyMarquee = ({ technologies }) => (
  <section
    aria-label="Technologies we work with"
    className="relative z-10 border-y border-slate-200 bg-white py-6"
  >
    <div className="mx-auto flex max-w-[84rem] flex-col gap-4 px-4 sm:px-6 lg:flex-row lg:items-center lg:gap-8 lg:px-8">
      {/* Inline label instead of a centered eyebrow */}
      <p className="shrink-0 whitespace-nowrap text-[13px] font-semibold uppercase tracking-[0.16em] text-slate-600 lg:border-r lg:border-slate-200 lg:pr-8">
          Technologies We Work With
        </p>

      <div className="mk-technology-marquee min-w-0 flex-1 overflow-hidden" role="presentation">
        <div className="mk-technology-marquee__track flex w-max items-center">
          <TechnologyItems technologies={technologies} />
          <div aria-hidden="true">
            <TechnologyItems technologies={technologies} />
          </div>
        </div>
      </div>
    </div>

    <style>{`
      .mk-technology-marquee {
        mask-image: linear-gradient(to right, transparent, black 6%, black 94%, transparent);
        -webkit-mask-image: linear-gradient(to right, transparent, black 6%, black 94%, transparent);
      }

      .mk-technology-marquee__track {
        animation: mk-technology-marquee 30s linear infinite;
        will-change: transform;
      }

      .mk-technology-marquee:hover .mk-technology-marquee__track {
        animation-play-state: paused;
      }

      @keyframes mk-technology-marquee {
        to { transform: translateX(-50%); }
      }

      @media (prefers-reduced-motion: reduce) {
        .mk-technology-marquee__track {
          animation: none;
          transform: translateX(0);
        }
      }
    `}</style>
  </section>
);

export default TechnologyMarquee;